/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from "react";
import moment from "moment/moment";
import FormDatePicker from "../../../../../common/components/FormDatePicker";
import InsightBox from "../InsightBox";

const FilterDatePicker = (props) => {
    const {
        ftOption,
        stateObj,
        handleSubmitFilter,
    } = props;

    if (!ftOption) return null;

    const { id, label, insight, isLocked, preview, infoText } = ftOption;

    // After submission the slice stores the full filter object at stateObj[id],
    // not just the date string. Unwrap it the same way FilterTextInput does.
    const rawValue = stateObj?.[id];
    const currentValue = (typeof rawValue === 'object' && rawValue !== null)
        ? rawValue.value
        : (rawValue ?? null);

    const handleDateChange = (dateObj) => {
        if (dateObj instanceof Date) {
            handleSubmitFilter({
                ...ftOption,
                value: moment(dateObj).format('YYYY-MM-DD')
            });
        }
    };

    return (
        <div>
            <FormDatePicker
                id={id}
                label={label}
                value={currentValue}
                format={'YYYY-MM-DD'}
                onChange={handleDateChange}
                disabled={isLocked}
                lockIcon={isLocked}
                isPreview={preview}
                infoText={infoText}
            />
            {insight && (
                <div style={{ marginTop: '8px' }}>
                    <InsightBox
                        text={insight.text}
                        title={insight.title}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterDatePicker;